import {Injectable} from '@angular/core';
import {BehaviorSubject,Observable} from "rxjs";
import {ConfigSMTP} from "@domain/admin/bibliotheque/notification/config-smtp";
import {NotificationService} from "@services/admin/bibliotheque/notification.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {handleResult} from "@share/utils/handle-result";
import {finalize} from "rxjs/operators";
import {Result} from "@domain/common/http/result";

/**
 * Service de gestion de la configuration d'envoi de mails
 */
@Injectable()
export class NotificationMailsService {
    /** Indicateur de sauvegarde en cours */
    isSaving: boolean = false;

    /** Subject sur la configuration SMTP */
    private configSMTPSubject: BehaviorSubject<ConfigSMTP> = new BehaviorSubject<ConfigSMTP>(null);

    /**
     * Constructeur
     *
     * @param notificationService Service HTTP des notifications
     * @param translateService Service de traduction
     * @param toastrService Service de notification
     */
    constructor(
        private notificationService: NotificationService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
    ) {
        //Chargement des données
        this.load();
    }

    /**
     * Retourne un observable de la configuration SMTP
     */
    getCurrent(): Observable<ConfigSMTP> {
        return this.configSMTPSubject.asObservable();
    }

    /**
     * Chargement de la configuration SMTP
     */
    load(): void {
        this.notificationService.loadConfigSMTP()
            .pipe(handleResult(this.translateService, this.toastrService, null, 'global.errors.generic'))
            .subscribe((result: Result) => {
                if (result?.data?.configSMTP) {
                    this.configSMTPSubject.next(result.data.configSMTP);
                } else {
                    //Initialisation d'une configuration vide
                    this.configSMTPSubject.next(new ConfigSMTP());
                }
            });
    }

    /**
     * Sauvegarde de la configuration SMTP
     */
    save(): void {
        //Récupération de la configuration courante
        const configSMTP = this.configSMTPSubject.getValue();

        //Début de la sauvegarde
        this.isSaving = true;

        //Appel du service HTTP
        this.notificationService.saveConfigSMTP(configSMTP)
            .pipe(
                handleResult(this.translateService, this.toastrService),
                finalize(() => this.isSaving = false)
            )
            .subscribe();
    }
}